/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { errorToObject, v2 } from "@prftesp/cle-logger";
import errorCodes from "../../../utility/errorCodes";
import { listDashboardUrlConfigs, updateDashboardUrlConfigs } from "../services/DashboardsService";
import { dashboardUrlConfigActions } from "./reducer";

const COMPONENT_NAME = "Admin settingsManager/context/dashboardManager/actions";

export const fetchDashboardUrlConfigList = async (dispatch) => {
	try {
		dispatch({ type: dashboardUrlConfigActions.DASHBOARD_URLS_LIST_GET });
		const existingConfigs = await listDashboardUrlConfigs();
		dispatch({
			type: dashboardUrlConfigActions.DASHBOARD_URLS_LIST_GET_SUCCESS,
			payload: existingConfigs,
		});
	} catch (error) {
		v2.error(`Error while fetching dashboard configurations.`, {
			additionalData: { error: errorToObject(error) },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.GET_DASHBOARD_URL_CONFIG,
		});
		dispatch({
			type: dashboardUrlConfigActions.DASHBOARD_URLS_LIST_GET_ERROR,
			error: "Failed to load dashboard configurations.",
		});
	}
};

export const saveDashboardUrlConfigList = async (dispatch, updatedDashboardUrls) => {
	try {
		dispatch({ type: dashboardUrlConfigActions.DASHBOARD_URLS_LIST_UPDATE });
		await updateDashboardUrlConfigs(updatedDashboardUrls);
		dispatch({ type: dashboardUrlConfigActions.DASHBOARD_URLS_LIST_UPDATE_SUCCESS });
	} catch (error) {
		v2.error(`Error while updating dashboard configurations`, {
			additionalData: { error: errorToObject(error) },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.UPDATE_DASHBOARD_URL_CONFIG,
		});
		dispatch({
			type: dashboardUrlConfigActions.DASHBOARD_URLS_LIST_UPDATE_ERROR,
			error: "Failed to save dashboard configurations.",
		});
	}
};

export const addDashboardUrlConfigAction = (dispatch) => {
	dispatch({ type: dashboardUrlConfigActions.DASHBOARD_URLS_LIST_ADD_NEW });
};

export const removeDashboardUrlConfigAction = (dispatch, reportId) => {
	dispatch({ type: dashboardUrlConfigActions.DASHBOARD_URLS_LIST_REMOVE, payload: reportId });
};

export const modifyDashboardUrlConfigAction = (dispatch, reportId, fieldName, fieldValue) => {
	dispatch({
		type: dashboardUrlConfigActions.DASHBOARD_URLS_LIST_MODIFY,
		reportId,
		payload: { fieldName, fieldValue },
	});
};

export const clearDashboardConfigChangesAction = (dispatch) => {
	dispatch({ type: dashboardUrlConfigActions.DASHBOARD_URLS_LIST_CLEAR_CHANGES });
};

export const reorderDashboardUrlsAction = (dispatch, dashboardUrls) => {
	dispatch({ type: dashboardUrlConfigActions.DASHBOARD_URLS_LIST_REORDER, payload: dashboardUrls });
};
